import { Button } from '@warp-ds/react';
import { useState } from 'react';
import { trackCreateOrRepublishAdButton } from '@/utils/tracking';

interface RepublishButtonProps {
    itemId: string | undefined;
}

export const RepublishButton = ({ itemId }: RepublishButtonProps) => {
    const [loading, setLoading] = useState(false);
    const atlasUrl = `/realestate/private/item/edit/${itemId}?adType=realestate-letting`;
    return (
        <Button
            onClick={() => {
                setLoading(true);
                trackCreateOrRepublishAdButton('finn', itemId, true);
                window.location.href = atlasUrl;
                setTimeout(() => {
                    setLoading(false);
                }, 10000);
            }}
            loading={loading}
            fullWidth
            type="button">
            Republiser annonse på FINN
        </Button>
    );
};
